import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { JoveButton } from '@jove-frontend/mui';
import { convertBytes } from '@jove-frontend/uikit';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { uniqueId } from 'lodash';
import { useDropzone } from 'react-dropzone';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JoveButtonUploadFiles = function JoveButtonUploadFiles(props) {
  var buttonText = props.buttonText,
      className = props.className,
      _props$maxFiles = props.maxFiles,
      maxFiles = _props$maxFiles === void 0 ? 1 : _props$maxFiles,
      selectFiles = props.selectFiles;

  var _useDropzone = useDropzone({
    accept: 'application/pdf',
    maxFiles: maxFiles,
    onDrop: function onDrop(acceptedFiles) {
      selectFiles === null || selectFiles === void 0 ? void 0 : selectFiles(acceptedFiles.map(function (item) {
        var sizeInfo = convertBytes(item.size, {
          fixLength: 2
        });
        return {
          id: uniqueId(),
          sizeText: "".concat(sizeInfo === null || sizeInfo === void 0 ? void 0 : sizeInfo.MB, " MB"),
          file: item
        };
      }));
    }
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      open = _useDropzone.open;

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({}, getRootProps({
    className: 'dropzone'
  })), {}, {
    onClick: open,
    className: clsx(className),
    children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps())), /*#__PURE__*/_jsx(JoveButton, {
      variant: "contained",
      children: buttonText
    })]
  }));
};

export default JoveButtonUploadFiles;